import type LabeledValueView from '@UI/Store/Shared/Views/LabeledValueView';
import type * as React from 'react';
import { Tag, type TagSeverity } from '@verclam/ui-kit';

/**
 * The single place that turns a `WorkflowRunDisplayStatus` value into a tag color. Frozen: a status
 * the server adds later falls back to `secondary` rather than throwing, until this table is extended.
 */
const STATUS_SEVERITIES: Readonly<Record<string, TagSeverity>> = Object.freeze({
	running: 'info',
	stalled: 'warning',
	failed: 'danger',
	partial: 'warning',
	succeeded: 'success',
	handled: 'secondary',
});

const FALLBACK_SEVERITY: TagSeverity = 'secondary';

type Props = {
	readonly status: LabeledValueView;
};

/** Renders a run's status exactly as the server decided it: `status.label` as text, `status.value` as the only key used to pick a color. */
const WorkflowRunStatusTag: React.FC<Props> = ({ status }) => {
	const severity = STATUS_SEVERITIES[status.value] ?? FALLBACK_SEVERITY;

	return <Tag value={status.label} severity={severity} rounded />;
};

export default WorkflowRunStatusTag;
